// import axios from "axios";
// import { RootState } from "@/app/store";

// let getStore: (() => RootState) | null = null;

// export const setStoreAccessor = (storeAccessor: () => RootState) => {
//   getStore = storeAccessor;
// };

// const apiClient = axios.create({
//   baseURL: process.env.NEXT_PUBLIC_API_BASE_URL || "http://localhost:8000",
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// // Request interceptor for custom headers
// apiClient.interceptors.request.use(
//   (config) => {
//     if (getStore) {
//       const state = getStore();
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// // Response interceptor for global error handling
// // apiClient.interceptors.response.use(
// //   (response) => response,
// //   (error) => {
// //     console.error('API Error:', error);
// //     return Promise.reject(error);
// //   }
// // );

// // apiClient.ts
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Agar API 401 de, aur user login page par na ho, toh fauran redirect karein
//     if (error.response && error.response.status === 401) {
//       if (
//         typeof window !== "undefined" &&
//         window.location.pathname !== "/auth/login"
//       ) {
//         window.location.href = "/auth/login"; // Yeh browser ka full reload karega aur cache break karega
//       }
//     }
//     console.error("API Error:", error);
//     return Promise.reject(error);
//   },
// );

// export default apiClient;

import axios from "axios";
import { decryptPayload, encryptPayload } from "../lib/crypto";
import {
  captureLogRocketError,
  createCorrelationId,
  getLogRocketSessionURL,
} from "../lib/logrocket";

const isFormData = (value: unknown): value is FormData =>
  typeof FormData !== "undefined" && value instanceof FormData;

const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL || "http://localhost:8000",
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

apiClient.interceptors.request.use(
  async (config) => {
    // ✅ Correlate every request with LogRocket and the backend logs.
    // - `x-request-id`     : unique per request, echoed back by the API and
    //                        logged next to the LogRocket session URL.
    // - `x-logrocket-session`: lets the backend tag its own logs with the
    //                        session replay (LogRocket "Custom Backend Tool").
    config.headers["x-request-id"] = createCorrelationId();

    const sessionUrl = getLogRocketSessionURL();
    if (sessionUrl) {
      config.headers["x-logrocket-session"] = sessionUrl;
    }

    if (config.data && !isFormData(config.data)) {
      const encrypted = await encryptPayload(config.data);
      config.data = { payload: encrypted };
    }
    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  async (response) => {
    const payload = response.data?.payload;
    if (typeof payload === "string") {
      try {
        response.data = await decryptPayload(payload);
      } catch (error) {
        console.error("Failed to decrypt response payload", error);
      }
    }
    return response;
  },
  (error) => {
    const status: number | undefined = error?.response?.status;

    // ✅ Report real failures (5xx / network down) to LogRocket with the ids
    // needed to jump into the backend logs. 4xx are user errors, not bugs.
    const isServerFailure = !error?.response || (status ?? 0) >= 500;
    if (isServerFailure) {
      captureLogRocketError(
        error instanceof Error ? error : new Error("API request failed"),
        {
          endpoint: String(error?.config?.url ?? "unknown"),
          method: String(error?.config?.method ?? "unknown").toUpperCase(),
          status: status ?? 0,
          requestId: String(error?.config?.headers?.["x-request-id"] ?? ""),
        },
      );
    }

    if (status === 401) {
      if (
        typeof window !== "undefined" &&
        window.location.pathname !== "/auth/login"
      ) {
        window.location.href = "/auth/login";
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
